import AutomaticDebit from "assets/images/AutomaticDebit.png";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { CloseButton, Container } from "../styles";

export type ModalAutomaticDebitProps = {
  show: boolean;
  onClose: () => void;
};

const ModalAutomaticDebit = ({
  show,
  onClose,
}: ModalAutomaticDebitProps): JSX.Element => {
  const [, setStatus] = useState("initial");

  const handleOnClose = (): void => {
    setStatus("initial");
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleOnClose}
      animation={false}
      centered
      dialogClassName="custom-modal"
    >
      <Modal.Body style={{ padding: 0 }}>
        <Container>
          <img
            src={AutomaticDebit}
            alt="modal debito automatico"
            loading="lazy"
            aria-describedby="descimage"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "10px",
            }}
          />
          <CloseButton onClick={handleOnClose}>X</CloseButton>{" "}
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAutomaticDebit;
